import { render } from "./googleFit.vue?vue&type=template&id=4557a3be"
import script from "./googleFit.js?vue&type=script&lang=js"
export * from "./googleFit.js?vue&type=script&lang=js"

import "./googleFit.vue?vue&type=style&index=0&id=4557a3be&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__